export default "__VITE_ASSET___OjvGh34__"